import {
  AccountUser,
  AiarAuthorization,
  AiarInfo,
  Beneficiary,
  DuplicatePaymentsType,
  FinancialInstitution,
  Office,
  PaymentAccount,
  SimpleClient,
  UserSettings,
} from '~domain/types';

export type AppState = {
  colorMode: 'dark' | 'light' | null;
  maintenanceMode: boolean;
  accountUser: AccountUser | null;
  userSettings: UserSettings | null;
  clientBadgeCount: number;
  notificationBadgeCount: number;
  paymentBadgeCount: number;
  unlinkedAccountsBadgeCount: number;
  accountsWithWarningBadgeCount: number;
  documentBadgeCount: number;
  office: Office | null;
  createClientIsLoading: boolean;
  documentUpdating: boolean;
  documentDownloadingId: string | null;
  selectingDocuments: boolean;
  renameDocumentIsLoading: boolean;
  toggleDocumentHiddenIsLoadingId: string | null;
  toggleDocumentSharedIsLoadingId: string | null;
  deleteDocumentIsLoading: boolean;
  fetchingDocumentPaymentDataId: string | null;
  paymentAccounts: PaymentAccount[];
  paymentClients: SimpleClient[];
  paymentDocumentType: 'image' | 'pdf' | null;
  paymentDocumentUrl: string | null;
  clientBeneficiaries: Beneficiary[];
  globalBeneficiaries: Beneficiary[];
  clientBeneficiariesLoading: boolean;
  globalBeneficiariesLoading: boolean;
  paymentInfoLoading: boolean
  paymentSaving: boolean;
  beneficiaryEditing: boolean;
  duplicatePaymentsType: DuplicatePaymentsType | null;
  duplicatePaymentsLatestDate: Date | null;
  viewDocumentUrl: string | null;
  viewDocumentType: 'image' | 'pdf' | null;
  fetchingDocumentAssignmentDataIds: string[];
  assignDocumentClients: SimpleClient[];
  assignDocumentType: 'image' | 'pdf' | null;
  assignDocumentUrl: string | null;
  assignDocumentIsLoading: boolean;
  fetchingDocumentProcessingData: boolean;
  processDocumentType: 'image' | 'pdf' | null;
  processDocumentUrl: string | null;
  xs2aInfoIsLoading: boolean;
  xs2aFinancialInstitutions: FinancialInstitution[];
  aiarInfoIsLoading: boolean;
  aiarInfo: AiarInfo | null;
  createAiarIsLoading: boolean;
  createAiarAuthorizationIsLoading: boolean;
  aiarAuthorization: AiarAuthorization | null;
  aiarAuthorizationError: boolean;
  createIsabelAuthorizationIsLoading: boolean;
  isabelAuthorizationError: boolean;
  newBudgetAppEnabled: boolean | null;
};

export const initialState: AppState = {
  colorMode: null,
  maintenanceMode: false,
  accountUser: null,
  userSettings: null,
  clientBadgeCount: 0,
  notificationBadgeCount: 0,
  paymentBadgeCount: 0,
  unlinkedAccountsBadgeCount: 0,
  accountsWithWarningBadgeCount: 0,
  documentBadgeCount: 0,
  office: null,
  createClientIsLoading: false,
  documentUpdating: false,
  documentDownloadingId: null,
  selectingDocuments: false,
  renameDocumentIsLoading: false,
  toggleDocumentHiddenIsLoadingId: null,
  toggleDocumentSharedIsLoadingId: null,
  deleteDocumentIsLoading: false,
  fetchingDocumentPaymentDataId: null,
  paymentAccounts: [],
  paymentClients: [],
  paymentDocumentType: null,
  paymentDocumentUrl: null,
  globalBeneficiaries: [],
  clientBeneficiaries: [],
  globalBeneficiariesLoading: false,
  clientBeneficiariesLoading: false,
  paymentSaving: false,
  paymentInfoLoading: false,
  beneficiaryEditing: false,
  duplicatePaymentsType: null,
  duplicatePaymentsLatestDate: null,
  viewDocumentUrl: null,
  viewDocumentType: null,
  fetchingDocumentAssignmentDataIds: [],
  assignDocumentClients: [],
  assignDocumentType: null,
  assignDocumentUrl: null,
  assignDocumentIsLoading: false,
  fetchingDocumentProcessingData: false,
  processDocumentType: null,
  processDocumentUrl: null,
  xs2aInfoIsLoading: false,
  xs2aFinancialInstitutions: [],
  aiarInfoIsLoading: false,
  aiarInfo: null,
  createAiarIsLoading: false,
  createAiarAuthorizationIsLoading: false,
  aiarAuthorization: null,
  aiarAuthorizationError: false,
  createIsabelAuthorizationIsLoading: false,
  isabelAuthorizationError: false,
  newBudgetAppEnabled: null,
};
